import { useState, useContext, memo, useCallback } from "react";
import { useTheme, useMediaQuery, Fade } from "@mui/material";

import Header from "./Header";
import Aside from "./Aside";
import fidelitis2 from "../../assets/fidelitis2.png";
import { UserContext } from "../Context/Context";
import { Navigate, Outlet } from "react-router-dom";
import "../Scss/stylesComponents.scss?v=1.1.6";
import "../../styles/App.scss?v=1.1.9";
import { useLocation } from "react-router-dom";

const Layout = memo(function Layout() {
  const [rtl] = useState(false);
  const location = useLocation();
  const theme = useTheme();

  const [toggled, setToggled] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [bgLoaded, setBgLoaded] = useState(false); // ← NUEVO: control de carga de imagen

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { userData, isLoading, isLoggedIn } = useContext(UserContext);
  const { user, userCompany } = userData || {};

  const handleToggleSidebar = useCallback((value) => {
    setToggled((prev) => (typeof value === "boolean" ? value : !prev));
  }, []);

  const handleCollapseSidebar = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  if (!isLoggedIn && !isLoading) return <Navigate to="/" replace />;

  const isLayoutLoading = isLoading || !user;

  return (
    <>
      {!isLayoutLoading ? (
        <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
          <Aside
            rtl={rtl}
            toggled={isMobile ? toggled : false}
            collapsed={!isMobile && collapsed}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapseSidebar={handleCollapseSidebar}
            userLogged={user}
            userCompany={userCompany}
            theme={theme}
            isMobile={isMobile}
          />

          <main>
            {/* Imagen de fondo con Fade solo cuando esté cargada */}
            <Fade in={bgLoaded} timeout={1000}>
              <img
                src={fidelitis2}
                className="backgroundImage"
                alt="fondo"
                onLoad={() => setBgLoaded(true)} // ← marca como cargada
                style={{ display: bgLoaded ? "block" : "none" }} // opcional para que no parpadee
              />
            </Fade>

            <Header handleToggleSidebar={handleToggleSidebar} />

            <div className="app-content">
              <Outlet />
            </div>
          </main>
        </div>
      ) : null}
    </>
  );
});

export default Layout;
